const Loader = () => (
  <div className="text-center">
    <div className="spinner-border" role="status"></div>
  </div>
);

export default Loader;
